export default "__VITE_ASSET__96b0417d__"